export default __webpack_public_path__ + "static/media/FolderIcon.73d303c3.svg";